import { Col, FormLabel, Row } from 'react-bootstrap';
import { FormCheckbox, FormInput } from '@components/Common/AwpFormInputs';
import React from 'react';
import * as Yup from 'yup';
import { isUnique } from '@awp/helpers/Utils';
import { CrudService } from '@awp/shared/CrudService';
import { ENTITY_TITLES } from '@awp/constants';

export class AvalancheProgramsService extends CrudService {
  constructor(mode) {
    const entityName = ENTITY_TITLES.AVALANCHE_PROGRAM;
    const entityPluralName = ENTITY_TITLES.AVALANCHE_PROGRAMS;
    super({ entityName, entityPluralName, mode });
  }

  static mapInitialValues(data) {
    return {
      ...data,
      status: data.IsActive === true ? 'Active' : 'Inactive',
    };
  }

  static mapFormToDTO(data) {
    return {
      ...data,
    };
  }

  static getValidations({ data, allEntities }) {
    const ENTITY_NAME = 'Avalanche Program';

    return Yup.object({
      Name: Yup.string()
        .trim()
        .max(50, 'Maximum 50 characters are allowed')
        .required(`${ENTITY_NAME} Name is a required field`)
        .test('Unique Name', `${ENTITY_NAME} Name must be unique`, function (value) {
          return isUnique(data, allEntities, 'Name', value);
        }),
      Code: Yup.string()
        .trim()
        .max(5, 'Maximum 5 characters are allowed')
        .required('Code is a required field')
        .test('Unique Code', `${ENTITY_NAME} Code must be unique`, function (value) {
          return isUnique(data, allEntities, 'Code', value);
        }),
    });
  }

  static getFields({ readOnly }) {
    return (
      <>
        <Row>
          <Col sm={4} className="mb-4">
            <FormInput label="Avalanche Program Name (required)" name="Name" id="Name" readOnly={readOnly} />
          </Col>
          <Col sm={4} className="mb-4">
            <FormInput label="Code (required)" id="Code" name="Code" readOnly={readOnly} />
          </Col>
          <Col sm={4} className="mb-4">
            <FormLabel>
              <strong>Status</strong>
            </FormLabel>
            <FormCheckbox label="Active" id="IsActive" name="IsActive" readOnly={readOnly} />
          </Col>
        </Row>
      </>
    );
  }
}
